<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="form!">
    <h2 class="text-base font-bold text-font-primary">Affected Items</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-select
            [required]="true"
            label="Quality Issue"
            placeholder="Select Quality Issue"
            formControlName="issueType"
            class="max-w-input"
        >
            @for (issueType of issueTypes; track issueType) {
            <sag-ui-option [value]="issueType">{{ issueType }}</sag-ui-option>
            }
        </sag-ui-select>
        @if (showCountrySpecificLabel) {
        <sag-ui-radio-group label="Country Specific Label Missing or Incorrect?" direction="row" [required]="true">
            <sag-ui-radio
                name="countrySpecificLabelMissing"
                formControlName="countrySpecificLabelMissing"
                [value]="countrySpecificLabelIssue.MISSING"
                >Missing</sag-ui-radio
            >
            <sag-ui-radio
                name="countrySpecificLabelMissing"
                formControlName="countrySpecificLabelMissing"
                [value]="countrySpecificLabelIssue.INCORRECT"
                >Incorrect</sag-ui-radio
            >
        </sag-ui-radio-group>
        } @if (showLabelError) {
        <sag-ui-select
            [required]="true"
            label="Item Type"
            placeholder="Select Item Type"
            formControlName="labelError"
            class="max-w-input"
        >
            @for (item of labelErrors | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>
        }
        <app-order-line-table
            [selected]="lineItems"
            [disabled]="disabled"
            (selectionChange)="handleSelectionChange($event)"
            currency="EUR"
        ></app-order-line-table>
        @if (!disabled) {
        <div class="flex items-center justify-end max-w-[1400px]">
            <sag-ui-button [disabled]="!valid || confirmed" (click)="setConfirmed()" size="sm">{{
                confirmed ? 'Confirmed' : 'Confirm'
            }}</sag-ui-button>
        </div>
        }
    </div>
</section>
